export default "assets/images/logo-1d57e660.png";